import React, { useState, useEffect } from 'react';
import Gallery from 'react-grid-gallery';

import './index.css';

const Component = () => {
    const URL = `${process.env.PUBLIC_URL}/_data/gallery/images.json`;

    const [content, setContent] = useState([]);

    const getImageThumbDims = (imageUrl) => {
        const img = new Image();
        img.src = imageUrl;

        const height = 220.0;
        const width = (img.width / img.height) * 220;

        return { width, height };
    };

    useEffect(() => {
        fetch(URL)
            .then((res) => res.json())
            .then((reply) => {
                const images = reply.map((item) => {
                    const imageUrl = `${process.env.PUBLIC_URL}/_static/gallery/${item.name}`;
                    const { width, height } = getImageThumbDims(imageUrl);
                    return {
                        src: imageUrl,
                        caption: item.description,
                        thumbnail: imageUrl,
                        thumbnailWidth: width,
                        thumbnailHeight: height
                        // width: 320,
                        // height: 180
                    };
                });

                // console.log(images);

                setContent(images);
            });
    }, []);

    return (
        <div className="gallery-content">
            <h3 id="Gallery">Photo Gallery</h3>
            <Gallery images={content} enableLightbox enableImageSelection={false} />
        </div>
    );
};

export default Component;
